import { GET_USER_GROUP } from '@/services/api/setting/user/userGroup'

export const userGroupField = (self) => {
  return {
    name: 'user_group_id',
    label: self.$t('global.field.userGroup'),
    type: 'value-help-v2',
    placeholder: `${self.$t('global.form.select')} ${self.$t('global.field.userGroup')}`,
    trackBy: 'id',
    displayedBy: 'name',
    isMandatory: true,
    help: true,
    validation: 'required',
    listGetter: async function (opts) {
      let result = {}
      const filter = {
        pagination: {
          page: opts?.page,
          show: opts?.limit,
        },
        search: opts?.search,
      }
  
      const res = await this.$apollo.query({
        query: GET_USER_GROUP,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...filter,
          },
        },
      })
  
      const ugroups = res.data.ugroups.ugroups
  
      result = {
        metadata: {
          total_count: ugroups.pagination.total,
          page: ugroups.pagination.page,
        },
        data: {
          paginated_result: ugroups.data,
        },
      }
  
      return result
    },
    tableFields: [
      {
        label: self.$t('global.field.userGroup'),
        key: 'name',
        isSortable: false,
      },
      {
        label: self.$t('global.field.vehicleGroup'),
        key: 'vgroups',
        isSortable: false,
        formatter: (value) => {
          return value?.length != null ? (value.length === 0 ? self.$t('global.text.allVehicleGroup') : value.length) : '-'
        },
      },
    ],
  }
}
